module.exports = __webpack_public_path__ + "img/icon-close-modal.5f00e46c.svg";